import { Injectable } from '@angular/core';
import { Message, MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private messageService: MessageService) { }

  add(mensaje: Message) {
    // Configura el mensaje con el tiempo de vida proporcionado o usa un valor predeterminado
    if (mensaje.life === undefined) {
      mensaje.life = 10000;
    }
    // Muestra el toast usando el MessageService
    this.messageService.add(mensaje);
  }
}
